import React from 'react';
import { Menu, MenuProps as AriaMenuProps } from 'react-aria-components';

import styles from './Menu.module.scss';

type Props<T> = {
  children: React.ReactNode;
} & AriaMenuProps<T>;

export const MenuList = <T extends object>(props: Props<T>) => {
  return (
    <Menu className={styles.MenuList} {...props}>
      {props.children}
    </Menu>
  );
};
